import React, { useState, useEffect } from "react";
import axios from "axios";
import nizlogo from '../../assets/nizlogo.png';
import { FaEnvelope, FaLock, FaExclamationTriangle, FaSpinner } from 'react-icons/fa';

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorType, setErrorType] = useState(""); // email, password, server, generic

  // Sayfa yüklendiğinde otomatik olarak token temizle (logout durumu için)
  useEffect(() => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userRole");
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Hata mesajlarını temizle
    setError("");
    setErrorType("");

    // Form doğrulama
    if (!email) {
      setError("E-posta adresi girilmelidir.");
      setErrorType("email");
      return;
    }

    if (!password) {
      setError("Şifre girilmelidir.");
      setErrorType("password");
      return;
    }

    try {
      setLoading(true);
      
      // API'ye login isteği gönder
      const response = await axios.post('http://esnakademi.com/api/auth/login', { email, password });
      const token = response.data.token;
      
      if (!token) {
        setError("Kimlik doğrulama başarısız. Geçersiz yanıt alındı.");
        setErrorType("server");
        setLoading(false);
        return;
      }
      
      // Token'ı localStorage'a kaydet
      localStorage.setItem("authToken", token);
      
      // Token'dan kullanıcı rolünü çıkar
      try {
        const payload = token.split('.')[1];
        const decodedPayload = JSON.parse(atob(payload));
        const userRole = decodedPayload.data?.role;
        
        console.log("Kullanıcı rolü:", userRole);
        
        // Rolü de localStorage'a kaydedelim (kolay erişim için)
        localStorage.setItem("userRole", userRole);
        
        // Rol bazlı yönlendirme
        if (userRole === "admin") {
          // Admin rolü için dashboard'a yönlendir
          window.location.href = "/dashboard";
        } else {
          // Diğer roller için öğrenci listesine yönlendir
          window.location.href = "/student-list";
        }
      } catch (e) {
        console.error("JWT decode error:", e);
        setError("Token çözümleme hatası oluştu.");
        setErrorType("server");
        setLoading(false);
      }
      
    } catch (error) {
      console.error("Login error:", error);
      setLoading(false);
      
      if (error.response) {
        // Sunucudan gelen hata yanıtı
        const errorData = error.response.data;
        
        // Erişim saati kısıtlaması kontrolü
        if (errorData?.error_type === "access_time_restriction") {
          setErrorType("access_time");
          const accessTimes = errorData.access_times;
          if (accessTimes) {
            setError(`${errorData.message}\n\nMevcut saat: ${accessTimes.current}\nGiriş saatleri: ${accessTimes.start} - ${accessTimes.end}`);
          } else {
            setError(errorData.message);
          }
        } else if (error.response.status === 401) {
          setError("E-posta veya şifre hatalı.");
          setErrorType("generic");
        } else if (error.response.status === 404) {
          setError("Kullanıcı bulunamadı.");
          setErrorType("email");
        } else if (error.response.status === 429) {
          setError("Çok fazla başarısız giriş denemesi. Lütfen daha sonra tekrar deneyin.");
          setErrorType("generic");
        } else {
          setError(errorData?.message || "Sunucu hatası, lütfen daha sonra tekrar deneyin.");
          setErrorType("server");
        }
      } else if (error.request) {
        // İstek yapıldı ama cevap alınamadı
        setError("Sunucuya bağlanılamadı. Lütfen internet bağlantınızı kontrol edin.");
        setErrorType("server");
      } else {
        // İstek oluşturulurken hata
        setError("Bilinmeyen bir hata oluştu: " + error.message);
        setErrorType("generic");
      }
    }
  };

  // const handlePasswordReset = () => {
  //   // Şifre sıfırlama işlemi yapılacak fonksiyon
  //   console.log("Şifre sıfırlama linki gönderildi.");
  //   alert("Şifre sıfırlama linki e-posta adresinize gönderildi.");
  // };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-blue-600 via-indigo-500 to-blue-400">
      <div className="bg-white rounded-lg shadow-2xl overflow-hidden w-full max-w-md">
        <div className="bg-gradient-to-r from-blue-700 to-indigo-600 py-6 px-4">
          <div className="flex justify-center">
            <img 
              src={nizlogo} 
              alt="ESN Akademi" 
              className="h-20 w-auto drop-shadow-md"
            />
          </div>
          <h2 className="mt-4 text-center text-2xl font-bold text-white tracking-wider drop-shadow-sm">
            ESN Akademi Yetkili Portalı
          </h2>
          <p className="mt-2 text-center text-indigo-100 text-sm">
            Sisteme erişmek için giriş yapın
          </p>
        </div>

        <div className="p-8">
          {/* Hata mesajı */}
          {error && (
            <div className={`mb-6 p-4 rounded-md flex items-start ${
              errorType === "server" 
                ? "bg-red-100 text-red-700" 
                : "bg-amber-50 text-amber-700"
            }`}>
              <FaExclamationTriangle className="mr-3 mt-1 flex-shrink-0" />
              <span>{error}</span>
            </div>
          )}

          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                E-posta Adresi
              </label>
              <div className={`relative rounded-md shadow-sm ${
                errorType === 'email' ? 'border-2 border-red-500' : ''
              }`}>
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <FaEnvelope className="text-gray-400" />
                </div>
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  placeholder="ornek@mail.com"
                  className={`block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200 ${
                    errorType === 'email' ? 'border-red-500 bg-red-50' : ''
                  }`}
                />
              </div>
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                Şifre
              </label>
              <div className={`relative rounded-md shadow-sm ${
                errorType === 'password' ? 'border-2 border-red-500' : ''
              }`}>
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <FaLock className="text-gray-400" />
                </div>
                <input
                  type="password"
                  name="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  placeholder="••••••••"
                  className={`block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200 ${
                    errorType === 'password' ? 'border-red-500 bg-red-50' : ''
                  }`}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                disabled={loading}
                className={`flex w-full justify-center items-center rounded-md px-4 py-3 text-base font-medium text-white shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all duration-200 ${
                  loading 
                    ? 'bg-indigo-400 cursor-not-allowed'
                    : 'bg-gradient-to-r from-blue-700 to-indigo-600 hover:from-blue-800 hover:to-indigo-700 focus:ring-indigo-500'
                }`}
              >
                {loading ? (
                  <>
                    <FaSpinner className="animate-spin mr-2" />
                    Giriş Yapılıyor...
                  </>
                ) : (
                  "Giriş Yap"
                )}
              </button>
            </div>

            <div className="mt-4 text-center">
              <p className="text-sm text-gray-600">
                Giriş yapamıyorsanız yönetici ile iletişime geçin
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
